import { $, $$, insertHTML } from '@3pc/dom';
import {
  glideControls,
  generateBullets,
  generateNumeric,
} from './glide-module-template';
// TODO: replace with https://gitlab.3pc.de/frontend/packages/lightbox-photoswipe
// import Lightbox from 'modules/lightbox/Lightbox';

let Glide;

export default class Slider {
  LOADED_CLASS = 'is-initialized';

  constructor(target, props) {
    this.target = target;
    this.config = props.config;
    this.cb = props.cb;
    this.glide = null;
    this.slideLength = 0;
    // this.lightbox = null;
    this.mousePos = null;
    this.appendTarget = props.config.appendTarget || this.target;
  }

  handleCallbacks = () => {
    this.cb && this.cb(this.glide);
  };

  setUpSlider = () => {
    this.glide = new Glide(this.target, this.config);

    // update arrow status after mount and runs
    this.glide.on(['mount.after', 'run.after'], () => {
      this.config.controls && this.updateArrowStatus();
      this.config.numeric && this.updateNumeric();
    });

    // listen for events in config
    if (this.config.events) {
      this.config.events.forEach(event => {
        this.glide.on(event.event, event.handler);
      });
    }

    /**
     * Add component to extend Glide functionalities.
     *
     * @param {Glide} Glide
     * @param {Object} Components
     * @param {EventsBus} Events
     */
    const self = this;
    const Components = (Glide, Components, Events) => {
      return {
        mount() {
          // get slide length
          self.slideLength =
            self.config.numericAmount || Components.Sizes.length;
          self.config.numeric && self.createNumeric(self.slideLength);
        },
      };
    };

    this.initSlider(Components);
  };

  initSlider = Components => {
    this.glide.mount({ Components });

    this.handleCallbacks();
  };

  updateArrowStatus = () => {
    const arrowLeft = $('.glide__controls .arrow-left', this.target);
    const arrowRight = $('.glide__controls .arrow-right', this.target);
    const type = this.glide.type;
    const index = this.glide.index + 1;

    /*
     * If type slider, catch if the active slide is the first or the last slide
     * so we can disable the Button
     * */
    if (type === 'slider') {
      if (index === 1) {
        arrowRight.removeAttribute('disabled');
        arrowLeft.setAttribute('disabled', 'true');
      } else if (index === this.slideLength) {
        arrowLeft.removeAttribute('disabled');
        arrowRight.setAttribute('disabled', 'true');
      } else {
        arrowLeft.removeAttribute('disabled');
        arrowRight.removeAttribute('disabled');
      }
    }
  };

  createBullets = () => {
    const createBulletsTemplate = generateBullets(
      $$('.glide__slide', this.target)
    );

    insertHTML(this.appendTarget, 'beforeend', createBulletsTemplate);
  };

  createControls = () => {
    insertHTML(this.appendTarget, 'beforeend', glideControls);
  };

  createNumeric = slidesLength => {
    const numericTemplate = generateNumeric(slidesLength);
    insertHTML(this.appendTarget, 'beforeend', numericTemplate);
  };

  updateNumeric = () => {
    $('.glide__numeric-index', this.target).innerText = this.glide.index + 1;
  };

  getMousePosition = e => {
    this.mousePos = {
      clientX: e.clientX,
      clientY: e.clientY,
    };
  };

  // initLightbox = () => {
  //   const glideTrack = $('.glide__track', this.target);

  //   this.lightbox = new Lightbox(this.target, {
  //     selector: '.lightbox-toggle',
  //     cb: lightbox => {
  //       // update slide index after every slide-change in the lightbox
  //       this.glide.go(`=${lightbox.getCurrentIndex()}`);
  //     },
  //   });

  //   /*
  //    * get mousePosition on moseDown and compare it with the new position on mouseUp.
  //    * So we can detect if the user did a static click or was just swiping.
  //    * This will prevent a bug if the glidebox is in use with a slider.
  //    * */
  //   glideTrack.addEventListener('mousedown', e => this.getMousePosition(e));

  //   glideTrack.addEventListener('mouseup', e => {
  //     const { clientX, clientY } = this.mousePos;
  //     if (clientX === e.clientX && clientY === e.clientY) {
  //       this.lightbox.open(this.glide.index);
  //     }
  //   });
  // };

  destroy = () => {
    if (!this.glide) return;

    const bullets = $('.glide__bullets', this.target);
    const controls = $('.glide__controls', this.target);
    const numeric = $('.glide__numeric', this.target);

    bullets && bullets.parentNode.removeChild(bullets);
    controls && controls.parentNode.removeChild(controls);
    numeric && numeric.parentNode.removeChild(numeric);

    this.target.classList.remove(this.LOADED_CLASS);

    this.glide.destroy();
  };

  init = () => {
    import(/* webpackChunkName: '@glidejs/glide' */ '@glidejs/glide').then(
      _ => {
        Glide = _.default;

        this.config.bullets && this.createBullets();
        this.config.controls && this.createControls();
        this.config.lightbox && this.initLightbox();

        this.setUpSlider();

        // Prevents non-styled layout before js is loaded
        // Make sure to hide slider without LOADED_CLASS via CSS
        this.target.classList.add(this.LOADED_CLASS);
      }
    );
  };
}
